import c from '@/styles/InstagramArticlesList';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from '@/utils/cn';
import { getPropStylesFactory } from '@/utils/getPropStylesFactory';

export interface InstagramArticlesListArticleGroupProps extends ComponentProps<'div'> {
  variant?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'primary'>;
  size?: ClassNameProp<'default'>;
}

export const InstagramArticlesListArticleGroupComponent: Component<InstagramArticlesListArticleGroupProps> = ({
  children,
  className,
  variant,
  colors,
  size,
  ...props
}) => {
  const getPropStyles = getPropStylesFactory(c);

  const variantClassName = getPropStyles('article_group_variant', variant, 'default');
  const colorClassName = getPropStyles('article_group_colors', colors, 'primary');
  const sizeClassName = getPropStyles('article_group_size', size, 'default');

  const componentClassName = cn(variantClassName, colorClassName, sizeClassName, className);

  return (
    <div className={componentClassName} {...props}>
      {children}
    </div>
  );
};
